module.exports = __webpack_public_path__ + "static/media/cost.ba06f2fe.svg";